import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class InfoResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("InfoResourcesPackage");
    }
    public get assets_info_actived_dot_png(): Texture {
        return this.resource<Texture>("assets/info/actived_dot.png");
    }
    public get assets_info_arrow_left_png(): Texture {
        return this.resource<Texture>("assets/info/arrow_left.png");
    }
    public get assets_info_arrow_right_png(): Texture {
        return this.resource<Texture>("assets/info/arrow_right.png");
    }
    public get assets_info_dot_png(): Texture {
        return this.resource<Texture>("assets/info/dot.png");
    }
    public get assets_info_erase_png(): Texture {
        return this.resource<Texture>("assets/info/erase.png");
    }
    public get assets_info_erase_triangles_png(): Texture {
        return this.resource<Texture>("assets/info/erase_triangles.png");
    }
    public get assets_info_refresh_png(): Texture {
        return this.resource<Texture>("assets/info/refresh.png");
    }
    public get assets_info_tutorial_atlas(): any {
        return this.resource<any>("assets/info/tutorial.atlas");
    }
    public get assets_info_tutorial_json(): Object {
        return this.resource<Object>("assets/info/tutorial.json");
    }
    public get assets_info_tutorial_png(): Texture {
        return this.resource<Texture>("assets/info/tutorial.png");
    }
}

